import axios from '../../api/instance';
import deepcopy from 'clone-deep';

const namespace = 'support_wizard/';

export const RESET_WIZARD = namespace + 'reset';
export const SET_TITLE = namespace + 'set_title';
export const SET_DETAIL = namespace + 'set_detail';

export const SUBMIT_SUPPORT_ISSUE = namespace + 'submit';

export const GET_TITLE_OPTIONS = namespace + 'get_title_list';
export const GET_DETAIL_OPTIONS = namespace + 'get_detail_list';
export const GET_TITLE = namespace + 'get_title';
export const GET_DETAIL = namespace + 'get_detail';
export const CAN_SUBMIT = namespace + 'can_submit';

export const TITLE_CUSTOM = 'custom';
export const DETAIL_CUSTOM = 'custom';

export const GET_APPOINTMENT = namespace + 'get_appointment';
export const SET_APPOINTMENT = namespace + 'set_appointment';

export default {
    state: {
        titleCode: '',
        titleText: '',
        detailsCode: '',
        detailsText: '',
        appointment: {
            moments: {},
            address: {
                street: '',
                number: '',
                postalCode: '',
                city: '',
                country: '',
            },
            comment: '',
        },
        wizard: {
            'hardness': ['hardness_too_high', 'hardness_too_low'],
            'salt_blocks': ['salt_too_high', 'salt_too_low', 'salt_block_doesnt_fit'],
            'malfunction': ['malfunction_leak', 'malfunction_broken', 'malfunction_error'],
            'custom': [],
        },
    },
    mutations: {
        [RESET_WIZARD]: (state) => {
            state.titleCode = '';
            state.titleText = '';
            state.detailsCode = '';
            state.detailsText = '';
            state.appointment = {
                moments: {},
                address: {
                    street: '',
                    number: '',
                    postalCode: '',
                    city: '',
                    country: '',
                },
                comment: '',
            };
        },
        [SET_TITLE]: (state, {code = '', text = ''} = {}) => {
            // If the code of the title changes then the details code might be from a different list and no longer valid
            if (state.titleCode !== code) {
                state.detailsCode = '';
                state.detailsText = '';
            }
            state.titleCode = code;
            state.titleText = text;
        },
        [SET_DETAIL]: (state, {code = '', text = ''} = {}) => {
            state.detailsCode = code;
            state.detailsText = text;
        },
        [SET_APPOINTMENT]: (state, value) => state.appointment = deepcopy(value),
    },
    actions: {
        [SUBMIT_SUPPORT_ISSUE]: ({commit, state}) => {
            const payload = {
                ...state,
            };
            return axios.post('support/api/support', payload)
                .then(ticket => {
                    commit(RESET_WIZARD);
                    return ticket;
                });
        },
    },
    getters: {
        [GET_TITLE_OPTIONS]: (state) => Object.keys(state.wizard),
        [GET_DETAIL_OPTIONS]: (state) => state.wizard[state.titleCode] || [],
        [GET_TITLE]: (state) => ({code: state.titleCode, text: state.titleText}),
        [GET_DETAIL]: (state) => ({code: state.detailsCode, text: state.detailsText}),
        [GET_APPOINTMENT]: (state) => deepcopy(state.appointment),
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/support_wizard.js